export const getGtag = (): ((...args: any[]) => void) => {
  const windowGa = window as any
  windowGa.dataLayer = windowGa.dataLayer || []
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function gtag(...args: any[]): void {
    // eslint-disable-next-line prefer-rest-params
    windowGa.dataLayer.push(arguments)
  }
  return gtag
}
